<template>
    <commonbody>
        <div class="corporation-details-header" slot="swiper">
        </div>
        <div :style="getCommonStyle.style" :class="getCommonStyle.class">
            <div class="map-box common-width-box">
                <div class="map-desc-box">
                    <div class="common-subtitle-box">
                        我们的酒庄<i>Our winery</i>
                    </div>
                    <div style="padding-top: 30px;">
                        <p>我们代理的酒庄都推行有机种植或者生物动力法种植。种植规模为中等偏小的家庭农庄。这里面有些是历史久远的家族传承式"百年老庄",也不乏几十年耕耘就取得巨大国际声望的创一代后起之秀。他们自己在农场里生活工作，照料自己的葡萄园，喝自己酿的葡萄酒。他们拒绝除化肥除草剂，希望自己的土地一直健康充满活力，他们的葡萄是干净可口的。</p>
                        <p>我们代理的酒庄都偏向于自然酿造。这些酒在市场上有各种名字:手工酒，生态酒，有机酒，生物动力酒，自然酒等等。最近几年"自然酒"头越来越多的葡萄酒爱好者所知晓。这些酒没有具体的定义，但是它们都有一些共同的特征就是在酿造的过程中极少的人工干预。比如他们拒绝使用商业酵母，而使用葡萄本身自带的原生酵母。这个可以原始地反映葡萄种植和酿酒环境。比如他们在酿酒过程谨慎克制硫化物的添加，并且拒绝使用其它的任何食品添加剂，尽管这些添加剂在商业葡萄酒里面很常见，也在法规监管以内。</p>
                        <p>有机种植，自然酿造！我们只选者那些真正能反应风土的特色美酒。尊重大自然，尊重风土规则，酒庄把大量的功夫花在葡萄园内，收获健康成亲的果实。酿酒师将他们的智慧和灵魂都投入到葡萄酒中，引导葡萄酒自己真诚地去表达。当然无论我们怎样去给这样的葡萄酒做分类或者标签，它们的前提必须是让人愉悦的美味的葡萄酒。</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-md-12 col-lg-6">
                        <img src="../../public/images/map.jpg" class="map-img">
                    </div>
                    <div class="col-6 col-md-12 col-lg-6">
                        <div class="map-content-box">
                            <div class="map-content-desc">
                                <div class="map-content-desc">我们的选酒理念</div>
                                <p style="margin-bottom: 10px;">亲临每个酒庄，精选纯净可口、反映风土的好酒；</p>
                                <p style="margin-bottom: 10px;">葡萄园必须是有机或生物动力或可持续性种植，不使用农药化肥<br>等化学物质；</p>
                                <p style="margin-bottom: 10px;">酒庄必须下工夫筛选健康成熟的葡萄来酿酒；</p>
                                <p style="margin-bottom: 10px;">酿酒理念必须是少人工干涉以突出葡萄本身品种以及风土特色；</p>
                            </div>
                            <div class="map-content-list">
                                <div class="map-list">
                                    <p>
                                        <CountUp :delay="delay" :endVal="30" :options="options" /><em>+</em>
                                    </p>
                                    <span>代理酒庄</span>
                                </div>
                                <div class="map-list">
                                    <p><CountUp :delay="delay" :endVal="60" :options="options" /><em>+</em></p>
                                    <span>葡萄酒产区</span>
                                </div>
                                <div class="map-list">
                                    <p><CountUp :delay="delay" :endVal="10" :options="options" /><em>+</em></p>
                                    <span>国家</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="clearfix common-width-box" id="case-box">
                <div class="winery-query-box">
                    <div class="winery-desc">
                        我们连续多年深入欧洲各大葡萄酒产区酒庄实地考察，品鉴。<br>
                        目前，旗下共独家代理来自法国，意大利，西班牙，葡萄牙，德国，奥地利，斯洛文尼亚等国家的38个精品自然酒庄共300余款葡萄酒。
                    </div>
                    <div class="case-content-select">
                        <el-select v-model="query.nation" placeholder="请选择国家" class="search-input" @change="countryChange">
                            <el-option label="全部国家" value=""></el-option>
                            <el-option v-for="(item, key) in countryData" :key="key" :label="item.nation" :value="item.nation">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.origin" placeholder="请选择产区" class="search-input" @change="originChange">
                            <el-option label="全部产区" value=""></el-option>
                            <el-option v-for="(item, key) in originOptions" :key="key" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="query.title" placeholder="请输入关键字" class="search-input" @change="selectCases" />
                    </div>
                </div>
                <div class="case-content-box clearfix">
                    <!-- <div class="case-content-left clearfix">
                        <div class="common-subtitle-box">
                            国家
                        </div>
                        <div class="case-content-left-box">
                            <div v-for="(item, key) in countryData" :key="key" :class="{ active: index === key }"
                                @click="nationClick(key)" :title="item.nation">
                                {{
                                item.nation
                            }}
                            </div>
                        </div>
                    </div> -->
                    <div class="case-content-right">
                        <div class="home-case-box" v-if="caseData.length > 0">
                            <div class="row mx-0">
                                <div class="col-3 col-md-6 col-lg-3 card border-0" v-for="(item, key) in caseData" :key="key"
                                    @click="caseDetails(item.id)">
                                    <img class="img-thumbnail" :src="'/express_api' + item.cover_url" :alt="item.title" />
                                    <div class="home-chateau-text">
                                        {{ item.title }} {{ item.english_title }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="none-box">
                            暂无酒庄数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </commonbody>
</template>
<script>
import commonbody from '@/components/commonbody.vue';
import * as casesApi from '@/api/cases';
// import { CountUp } from 'countup.js';
import CountUp from 'vue-countup-v2';
import { mapGetters } from 'vuex';

export default {
    name: "Chateau",
    components: {
        commonbody,
        CountUp,
    },
    data() {
        return {
            index: '',
            countryData: [],
            //案例展示
            caseData: [],
            query: {
                nation: "",
                origin: "",
            },

            delay: 500,
            endVal: '',

            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: '',
            },

        }
    },
    computed: {
        ...mapGetters(['getCommonStyle']),
        originOptions() {
            let array = [];
            let index = this.countryData.findIndex(item => {
                return item.nation == this.query.nation;
            });

            if (index == -1) {
                this.countryData.forEach(item => {
                    array.push(...(item.children || []));
                })
            } else {
                array = this.countryData[index].children || [];
            }

            return array;
        },
    },
    created() {
        this.paramsUrl();
    },
    methods: {
        countryChange() {
            this.query.origin = '';
            this.selectCases();
        },
        originChange() {
            if (this.query.nation == "") {
                this.countryData.forEach(item => {
                    item?.children?.forEach(value => {
                        if (value.value == this.query.origin) {
                            this.query.nation = item.nation;
                        }
                    });
                });
            }
            this.selectCases();
        },
        /**
         * @desc 点击进案例详情
         */
        caseDetails(id) {
            this.$router.push({
                path: '/wineryDetails',
                query: {
                    id
                }
            })
        },
        /**
         * @desc 检测页面是否带了type值初始化type
         */
        paramsUrl() {
            let query = this.$route.query;

            if (typeof query.type != 'undefined' && query.type != '0') {
                this.type = query.type;
            } else {
                this.type = 0;
            }
            this.selectCases();
            this.selectNation();
        },
        /**
         * @desc 获取案例数据
         */
        selectCases() {
            let params = {
                ...this.query
            };

            // if (this.index !== '') {
            //     params.nation = this.countryData[this.index].value;
            // }

            if (!params.nation) {
                delete params.nation;
            }
            if (!params.origin) {
                delete params.origin;
            }
            casesApi.selectCases(params).then(res => {
                this.caseData = res.data || [];
            })
        },
        selectNation() {
            let params = {};
            casesApi.selectNation(params).then(res => {
                let array = [],
                    map = new Map();

                res.data.forEach(item => {
                    if (!map.has(item.nation)) {
                        map.set(item.nation, true);
                        array.push({
                            nation: item.nation,
                            value: item.nation,
                            children: [{
                                label: item.origin,
                                value: item.origin
                            }]
                        });
                    } else {
                        let index = array.findIndex(value => {
                            return value.nation == item.nation;
                        });

                        if (array[index].children) {
                            array[index].children = [...array[index].children, { label: item.origin, value: item.origin }];
                        }
                    }
                })
                this.countryData = array;
            })
        },
        nationClick(key) {
            this.index = key;
            this.selectCases();
        }
    },
    mounted() {

    }
}
</script>
<style lang="scss" scoped>
.corporation-details-header {
    height: 0;
    width: 100%;
    position: relative;
    // background: url('../../public/images/jz1.png') center;
    background-size: cover;
}

.map-box {
    // width: 80%;
    max-width: 1536px;
    margin: 0 auto;
    margin-bottom: 80px;
    margin-top: 50px;

    .map-desc-box {
        text-align: left;
        color: #6a0b2d;
        margin-bottom: 50px;

        p {
            margin-bottom: 20px;
        }
    }

    .map-content-box {
        color: #6a0b2d;
        padding-top: 50px;

        .map-content-desc {
            text-align: left;
            margin-bottom: 30px;
            margin-top: 20px;

            .map-content-desc {
                font-size: 1.2em;
                font-weight: bold;
                margin-bottom: 20px;
            }
        }

        .map-content-list {
            display: flex;
            width: 80%;
            justify-content: space-between;
        }
    }

    .map-list {
        // padding-top: 16%;
        // padding-right: 55%;

        p {
            span{
                color: #6a0b2d;
                font-size: 4em;
                font-weight: 600;
                font-family: serif;
                line-height: 1;
                margin-bottom: 12px;
                display: inline;
                text-transform: uppercase;
                font-family: serif;
            }

            em {
                color: #6a0b2d;
                font-size: 48px;
                font-weight: 500;
                line-height: 1;
                margin: 0;
                padding: 0;
                display: inline-block;
                font-family: serif;
            }
        }

        span {
            width: 100%;
            color: #6a0b2d;
            font-size: 1.1em;
            line-height: 1.4;
        }
    }

    img {
        max-width: 80%;
        // float: left;
        transition: all 0.4s;
    }

    .map-img:hover{
        transform: scale(1.4);
    }
}

#case-box {
    // width: 80%;
    max-width: 1536px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    
    .winery-query-box {
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        
        .winery-desc {
            color: #6a0b2d;
            text-align: left;
            margin-bottom: 40px;
        }
        .case-content-select {
            text-align: left;

            .search-input,
            select {
                height: 30px;
                width: 200px;
                margin-right: 10px;
            }
        }
    }

    .case-content-box {
        height: calc(100% - 200px);
        margin: 0 auto;
        padding: 20px 0;
        display: flex;
        padding-top: 30px;
        padding-bottom: 160px;

        .case-content-left {
            width: 150px;
            // float: left;
            padding-right: 50px;
            border-right: 1px solid #dedede;

            .common-subtitle-box {
                margin: 0;
                margin-bottom: 20px;
            }

            .case-content-left-box {
                width: 100%;
                font-size: 1.1em;

                div {
                    width: 100%;
                    cursor: pointer;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    line-height: 30px;

                    &:hover,
                    &.active {
                        color: #470125;
                        font-weight: bold;
                        // border-bottom: 1px solid #470125;
                    }
                }
            }
        }

        .case-content-right {
            // width: calc(100% - 150px);
            // height: 100%;
            // float: left;
            // overflow-y: auto;
            // padding-left: 40px;
            width: 100%;
            // padding: 0 20px;

            .home-case-box {
                img {
                    // height: 250px;
                }

                .home-chateau-text {
                    cursor: pointer;
                    padding: 10px;
                    font-size: 1em;
                    text-align: left;
                }
            }
        }
    }

    .home-case-box {

        .card {
            position: relative;
            overflow: hidden;
            cursor: pointer;
            border-radius: 0;
            padding: 10px;

            img {
                // height: 390px;
                transition: all 0.2s linear;
            }

            .card-body {
                // display: none;
                transition: all 0.2s linear;
                position: absolute;
                bottom: 0;
                background: rgba(0, 0, 0, .7);
                width: 100%;
                color: #fff;
                line-height: 24px;
                box-sizing: border-box;
                padding-left: 30px;
                text-align: left;
                transition: all 0.2s linear;
                transform: rotateY(90deg);

                h4 {
                    font-size: 1.1em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                p {
                    font-size: 1em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            &:hover {
                img {
                    // transform: scale(1.2);
                }

                .card-body {
                    // display: block;
                    transform: rotate(0);
                }
            }
        }
    }

}
</style>